import { PageHeader, Select, Space, Tag, Tooltip, message, Modal } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    DownloadOutlined,
    EyeOutlined,
    FileImageOutlined,
    FilePdfOutlined,
} from "@ant-design/icons";
import {
    ButtonItem,
    ModalItem,
    SegmentedItem,
    SelectItem,
    TableItemDinamico,
} from "../../../../Components/Items";
import Compress from "../../../../Components/Compress";
import moment from "moment";

const { Option } = Select;

// Arriba de esto se pide confirmacion antes de armar el ZIP: se construye en
// memoria del navegador.
const MAX_ARCHIVOS_SIN_CONFIRMAR = 50;
// Cuantas descargas simultaneas como maximo, para no abrir cientos de
// conexiones contra el servidor de una sola vez.
const DESCARGAS_EN_PARALELO = 5;

// Las urls se guardan con path.join de Windows, asi que traen "\" y a veces un
// "../" heredado del front viejo.
const rutaLimpia = (url) =>
    String(url || "").replace(/\\/g, "/").replace(/^(\.\.\/)+/, "").replace(/^\/+/, "");

// Para fetch: ruta relativa. En produccion es el mismo origen y en desarrollo el
// proxy de CRA la reenvia al backend, asi que no hay CORS de por medio.
const urlDescarga = (url) => "/" + rutaLimpia(url);

// Para previsualizar en <img>/<iframe>: mismo criterio que EditarLote.js, porque
// el proxy de CRA no reenvia peticiones con Accept: text/html (el iframe del PDF).
const urlVista = (url) =>
    (process.env.NODE_ENV === "development" ? "http://192.168.100.6:3001/" : "/") +
    rutaLimpia(url);

const esImagen = (tipo) => tipo === "imagen";

// Nombre unico dentro del ZIP: dos lotes distintos pueden tener el mismo
// "certificado.pdf".
const nombreUnicoZip = (usados, numeroLote, nombre) => {
    const base = numeroLote ? `${numeroLote}_${nombre}` : nombre;
    if (!usados.has(base)) {
        usados.add(base);
        return base;
    }
    const punto = base.lastIndexOf(".");
    const sinExt = punto > 0 ? base.slice(0, punto) : base;
    const ext = punto > 0 ? base.slice(punto) : "";
    let i = 2;
    while (usados.has(`${sinExt}_${i}${ext}`)) i++;
    const final = `${sinExt}_${i}${ext}`;
    usados.add(final);
    return final;
};

class ArchivosLotes extends Component {
    tableRef = null;
    state = {
        loading: false,
        descargando: false,
        datos: [],
        totalRecords: 0,
        // Modo pedido por el Segmented.
        agrupar: "archivo",
        // Modo del que son los datos que hay en pantalla. Se setea con lo que
        // regresa el backend para no repintar las columnas antes de que lleguen
        // los datos del nuevo modo.
        modoDatos: "archivo",
        proyectoId: undefined,
        tipoArchivo: undefined,
        objetoProyectos: [],
        // { [rowKey]: [{ name, url, numero }] } — se mantiene aparte del
        // rowSelection porque antd solo entrega las filas de la pagina actual y
        // para el ZIP hacen falta el nombre y la url de cada archivo.
        seleccionados: {},
        selectedRowKeys: [],
        previsualizar: false,
        previsualizarUrl: "",
        previsualizarNombre: "",
        previsualizarEsImagen: false,
    };

    claveStorage() {
        return "archivosLotesFiltrosTabla" + this.props.empresaId;
    }

    // TableItemDinamico restaura sus filtros externos desde localStorage y los
    // vuelve a mandar al backend, pero no puede reponer estos dos Selects: sin
    // esto la tabla vendria filtrada por proyecto mientras el Select dice "Todos".
    // Corre despues del componentDidMount del hijo, asi que si la tabla ya
    // descarto la entrada por vieja (TTL de 10 min) aqui tampoco se lee nada.
    restaurarSelects() {
        try {
            const guardado = localStorage.getItem(this.claveStorage());
            if (!guardado) return;
            const { filtros } = JSON.parse(guardado);
            if (!filtros) return;
            this.setState({
                proyectoId: filtros.proyectoId,
                tipoArchivo: filtros.tipoArchivo,
            });
        } catch (error) {
            // Un localStorage corrupto no debe tumbar la pantalla.
        }
    }

    async componentDidMount() {
        this.restaurarSelects();

        // La tabla se consulta sola al montarse (TableItemDinamico), aqui solo se
        // cargan los proyectos del filtro.
        await axios
            .post(
                "proyectos/selectProyectos",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status !== 404) {
                    this.setState({
                        objetoProyectos: res.data.map((value) => (
                            <Option value={value._id} key={value._id}>
                                {value.nombre}
                            </Option>
                        )),
                    });
                }
            })
            .catch(() => {
                message.error("Error al consultar los proyectos");
            });
    }

    atras = () => {
        this.props.history.goBack();
    };

    consultarArchivos(params) {
        this.setState({ loading: true });

        axios
            .post(
                "lotes/selectArchivosLotes",
                {
                    empresaId: this.props.empresaId,
                    ...params,
                    limit: params.pageSize,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        loading: false,
                        datos: res.data.data || [],
                        totalRecords: res.data.totalRecords || 0,
                        modoDatos: res.data.agrupar || "archivo",
                    });
                } else {
                    this.setState({ loading: false, datos: [], totalRecords: 0 });
                    message.error("Error al consultar los archivos de los lotes");
                }
            })
            .catch(() => {
                this.setState({ loading: false, datos: [], totalRecords: 0 });
                message.error("Error al consultar los archivos de los lotes");
            });
    }

    // updateExternalFilters REEMPLAZA el objeto completo de filtros externos, asi
    // que siempre hay que mandar el conjunto entero y no solo el que cambio.
    aplicarFiltrosExternos(cambios) {
        this.setState({ ...cambios, selectedRowKeys: [], seleccionados: {} }, () => {
            if (this.tableRef) {
                this.tableRef.updateExternalFilters({
                    valor: this.state.agrupar,
                    proyectoId: this.state.proyectoId,
                    tipoArchivo: this.state.tipoArchivo,
                });
            }
        });
    }

    onChangeAgrupar(value) {
        this.aplicarFiltrosExternos({ agrupar: value });
    }

    onChangeProyecto(value) {
        this.aplicarFiltrosExternos({ proyectoId: value === 0 ? undefined : value });
    }

    onChangeTipo(value) {
        this.aplicarFiltrosExternos({ tipoArchivo: value === 0 ? undefined : value });
    }

    // "Limpiar Filtros" de la tabla borra los filtros externos, asi que los
    // Selects tienen que volver a "Todos" para no mentir sobre lo que se pidio.
    onLimpiarFiltros = () => {
        this.setState({
            proyectoId: undefined,
            tipoArchivo: undefined,
            selectedRowKeys: [],
            seleccionados: {},
        });
    };

    abrirPrevisualizar(archivo) {
        this.setState({
            previsualizar: true,
            previsualizarUrl: urlVista(archivo.url),
            previsualizarNombre: archivo.name,
            previsualizarEsImagen: esImagen(archivo.tipo),
        });
    }

    cerrarPrevisualizar = () => {
        this.setState({ previsualizar: false, previsualizarUrl: "" });
    };

    // Baja los archivos de a `DESCARGAS_EN_PARALELO`. Los que fallen se reportan
    // al final en vez de abortar el ZIP completo.
    async bajarArchivos(archivos) {
        const usados = new Set();
        const resultados = [];
        const fallidos = [];

        for (let i = 0; i < archivos.length; i += DESCARGAS_EN_PARALELO) {
            const tanda = archivos.slice(i, i + DESCARGAS_EN_PARALELO);
            // eslint-disable-next-line no-await-in-loop
            const contenidos = await Promise.all(
                tanda.map(async (archivo) => {
                    try {
                        const respuesta = await fetch(urlDescarga(archivo.url));
                        if (!respuesta.ok) throw new Error(String(respuesta.status));
                        return { archivo, blob: await respuesta.blob() };
                    } catch (error) {
                        return { archivo, blob: null };
                    }
                })
            );

            contenidos.forEach(({ archivo, blob }) => {
                if (blob) {
                    resultados.push({
                        nombre: nombreUnicoZip(usados, archivo.numero, archivo.name),
                        contenido: blob,
                    });
                } else {
                    fallidos.push(archivo.name);
                }
            });
        }

        return { resultados, fallidos };
    }

    async descargarUno(archivo) {
        this.setState({ descargando: true });
        try {
            const respuesta = await fetch(urlDescarga(archivo.url));
            if (!respuesta.ok) throw new Error(String(respuesta.status));
            const blob = await respuesta.blob();
            // Compress con facturaZip=true baja los archivos sueltos, sin ZIP.
            Compress([{ nombre: archivo.name, contenido: blob }], archivo.name, true);
        } catch (error) {
            message.error(`No se pudo descargar ${archivo.name}`);
        }
        this.setState({ descargando: false });
    }

    async descargarZip(archivos, nombreZip) {
        if (!archivos || archivos.length === 0) {
            message.warning("No hay archivos para descargar");
            return;
        }

        const arrancar = async () => {
            this.setState({ descargando: true });
            // message.loading regresa la funcion que cierra ESE mensaje.
            // message.destroy(key) solo existe desde antd 4.23 y aqui hay 4.15.
            const cerrarCarga = message.loading(
                `Descargando ${archivos.length} archivo(s)...`,
                0
            );

            const { resultados, fallidos } = await this.bajarArchivos(archivos);

            cerrarCarga();
            this.setState({ descargando: false });

            if (resultados.length === 0) {
                message.error("No se pudo descargar ninguno de los archivos");
                return;
            }

            Compress(resultados, nombreZip);

            if (fallidos.length > 0) {
                message.warning(
                    `${fallidos.length} archivo(s) no se pudieron descargar: ${fallidos
                        .slice(0, 3)
                        .join(", ")}${fallidos.length > 3 ? "..." : ""}`
                );
            }
        };

        if (archivos.length > MAX_ARCHIVOS_SIN_CONFIRMAR) {
            Modal.confirm({
                title: "Descargar " + archivos.length + " archivos",
                content:
                    "El ZIP se arma en tu navegador, asi que con esta cantidad puede tardar y consumir bastante memoria. ¿Continuar?",
                okText: "Descargar",
                cancelText: "Cancelar",
                onOk: arrancar,
            });
            return;
        }

        await arrancar();
    }

    descargarSeleccionados() {
        const archivos = this.state.selectedRowKeys.reduce((acumulado, key) => {
            const delRenglon = this.state.seleccionados[key];
            return delRenglon ? acumulado.concat(delRenglon) : acumulado;
        }, []);
        this.descargarZip(archivos, "archivos_lotes");
    }

    // Todos los archivos de un lote (modo "Por lote").
    archivosDeLote(record) {
        return [
            ...(record.archivos || []).map((a) => ({ ...a, tipo: "pdf", numero: record.numero })),
            ...(record.imagenes || []).map((i) => ({ ...i, tipo: "imagen", numero: record.numero })),
        ];
    }

    // Columnas que comparten los dos modos: describen el LOTE, no el archivo.
    columnasDelLote() {
        return [
            {
                title: (
                    <span style={{ whiteSpace: "normal", wordBreak: "break-word", display: "block", lineHeight: 1.3 }}>
                        Clave / Codigo de Barras
                    </span>
                ),
                key: "claveCodigoBarras",
                width: "10%",
                render: (record) => (
                    <div>
                        <div style={{ fontWeight: 400, color: "#6a6a6a" }}>{record.clave}</div>
                        <div style={{ color: "#000000", fontSize: "12px", fontWeight: 500 }}>
                            {record.codigoBarras}
                        </div>
                    </div>
                ),
            },
            {
                title: "Descripcion",
                dataIndex: "descripcion",
                key: "descripcion",
                buscar: "descripcion",
                width: "14%",
            },
            {
                title: "Cliente",
                dataIndex: "clienteNombre",
                key: "clienteNombre",
                buscar: "clienteNombre",
                width: "13%",
            },
            {
                title: "Lote",
                dataIndex: "numero",
                key: "numero",
                buscar: "numero",
                width: "8%",
            },
            {
                title: "Permiso",
                key: "permisoCaza",
                buscar: "permisoCaza",
                width: "11%",
                render: (record) => (
                    <div>
                        <div style={{ color: "#000000", fontWeight: 500 }}>{record.permisoCaza}</div>
                        {record.tipoPermiso && (
                            <div style={{ fontSize: "11px", color: "#6a6a6a" }}>{record.tipoPermiso}</div>
                        )}
                    </div>
                ),
            },
            {
                title: "Caducidad",
                dataIndex: "caducidad",
                key: "caducidad",
                sorter: true,
                width: "9%",
                render: (value) => (value ? moment(value).format("DD/MM/YYYY") : ""),
            },
            {
                title: "Proyecto",
                dataIndex: "proyectoNombre",
                key: "proyectoNombre",
                width: "10%",
            },
        ];
    }

    columnasPorArchivo() {
        return [
            {
                title: "Archivo",
                dataIndex: "nombreArchivo",
                key: "nombreArchivo",
                buscar: "nombreArchivo",
                sorter: true,
                width: "18%",
                render: (value, record) => (
                    <Space size="small">
                        {esImagen(record.tipo) ? (
                            <FileImageOutlined style={{ color: "#1E88E5" }} />
                        ) : (
                            <FilePdfOutlined style={{ color: "#df0101" }} />
                        )}
                        <span>{value}</span>
                    </Space>
                ),
            },
            {
                title: "Tipo",
                dataIndex: "tipo",
                key: "tipo",
                width: "7%",
                render: (value) =>
                    esImagen(value) ? (
                        <Tag color="blue" className="square-tag">Imagen</Tag>
                    ) : (
                        <Tag color="red" className="square-tag">PDF</Tag>
                    ),
            },
            ...this.columnasDelLote(),
            {
                title: "Accion",
                key: "accion",
                align: "center",
                width: "10%",
                render: (record) => (
                    <Space size="small" direction="horizontal">
                        <Tooltip title="Ver archivo" placement="top" overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                azul
                                icon={<EyeOutlined />}
                                onClick={() =>
                                    this.abrirPrevisualizar({
                                        name: record.nombreArchivo,
                                        url: record.url,
                                        tipo: record.tipo,
                                    })
                                }
                            />
                        </Tooltip>
                        <Tooltip title="Descargar" placement="top" overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                morado
                                icon={<DownloadOutlined />}
                                onClick={() =>
                                    this.descargarUno({ name: record.nombreArchivo, url: record.url })
                                }
                            />
                        </Tooltip>
                    </Space>
                ),
            },
        ];
    }

    columnasPorLote() {
        return [
            ...this.columnasDelLote(),
            {
                title: "PDFs",
                dataIndex: "totalArchivos",
                key: "totalArchivos",
                align: "center",
                width: "8%",
                render: (value) =>
                    value > 0 ? <Tag color="red" className="square-tag">{value}</Tag> : "",
            },
            {
                title: "Imagenes",
                dataIndex: "totalImagenes",
                key: "totalImagenes",
                align: "center",
                width: "8%",
                render: (value) =>
                    value > 0 ? <Tag color="blue" className="square-tag">{value}</Tag> : "",
            },
            {
                title: "Accion",
                key: "accion",
                align: "center",
                width: "8%",
                render: (record) => (
                    <Tooltip title="Descargar todos" placement="top" overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                        <ButtonItem
                            type="default"
                            size="small"
                            morado
                            icon={<DownloadOutlined />}
                            onClick={() =>
                                this.descargarZip(
                                    this.archivosDeLote(record),
                                    `lote_${record.numero || record._id}`
                                )
                            }
                        />
                    </Tooltip>
                ),
            },
        ];
    }

    filaExpandida = (record) => {
        const archivos = this.archivosDeLote(record);
        if (archivos.length === 0) return <span>Este lote no tiene archivos</span>;

        return (
            <div style={{ paddingLeft: 24 }}>
                {archivos.map((archivo, index) => (
                    <div
                        key={`${record._id}-${index}`}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            padding: "2px 0",
                        }}
                    >
                        {esImagen(archivo.tipo) ? (
                            <FileImageOutlined style={{ color: "#1E88E5" }} />
                        ) : (
                            <FilePdfOutlined style={{ color: "#df0101" }} />
                        )}
                        <span style={{ flex: 1 }}>{archivo.name}</span>
                        <ButtonItem
                            type="default"
                            size="small"
                            azul
                            icon={<EyeOutlined />}
                            onClick={() => this.abrirPrevisualizar(archivo)}
                        />
                        <ButtonItem
                            type="default"
                            size="small"
                            morado
                            icon={<DownloadOutlined />}
                            onClick={() => this.descargarUno(archivo)}
                        />
                    </div>
                ))}
            </div>
        );
    };

    // Conserva lo seleccionado en otras paginas: antd solo entrega las filas de
    // la pagina visible, y para armar el ZIP hacen falta el nombre y la url de
    // cada archivo, no solo la clave del renglon.
    // Cada clave guarda un ARREGLO de archivos: en modo "archivo" es uno solo y
    // en modo "lote" son todos los del lote.
    onChangeSeleccion = (selectedRowKeys, selectedRows) => {
        const previos = this.state.seleccionados;
        const deEstaPagina = {};

        selectedRows.forEach((row) => {
            if (!row) return;
            deEstaPagina[this.claveFila(row)] =
                this.state.modoDatos === "lote"
                    ? this.archivosDeLote(row)
                    : [{ name: row.nombreArchivo, url: row.url, numero: row.numero }];
        });

        const mapa = {};
        selectedRowKeys.forEach((key) => {
            const archivos = deEstaPagina[key] || previos[key];
            if (archivos) mapa[key] = archivos;
        });

        this.setState({ selectedRowKeys, seleccionados: mapa });
    };

    // Cuantos ARCHIVOS representa la seleccion (en modo lote, un renglon son varios).
    totalArchivosSeleccionados() {
        return this.state.selectedRowKeys.reduce((total, key) => {
            const archivos = this.state.seleccionados[key];
            return total + (archivos ? archivos.length : 0);
        }, 0);
    }

    claveFila = (record) =>
        this.state.modoDatos === "lote"
            ? String(record._id)
            : `${record.loteId}|${record.url}`;

    render() {
        const porLote = this.state.modoDatos === "lote";
        const columns = porLote ? this.columnasPorLote() : this.columnasPorArchivo();
        const seleccionados = this.state.selectedRowKeys.length;

        return (
            <>
                <PageHeader
                    onBack={this.atras}
                    title="Archivos de Lotes"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <Space style={{ width: "100%" }} wrap>
                            <SegmentedItem
                                options={[
                                    { label: "Por archivo", value: "archivo" },
                                    { label: "Por lote", value: "lote" },
                                ]}
                                value={this.state.agrupar}
                                onChange={this.onChangeAgrupar.bind(this)}
                            />
                            <SelectItem
                                placeholder="Tipo"
                                width={140}
                                onChange={this.onChangeTipo.bind(this)}
                                value={this.state.tipoArchivo || 0}
                            >
                                <Option value={0}>Todos</Option>
                                <Option value="pdf">PDF</Option>
                                <Option value="imagen">Imagenes</Option>
                            </SelectItem>
                            <SelectItem
                                placeholder="Proyecto"
                                width={200}
                                onChange={this.onChangeProyecto.bind(this)}
                                value={this.state.proyectoId || 0}
                            >
                                <Option value={0}>Todos</Option>
                                {this.state.objetoProyectos}
                            </SelectItem>
                        </Space>
                    }
                />

                {seleccionados > 0 && (
                    <div
                        style={{
                            backgroundColor: "white",
                            padding: "8px 16px",
                            marginBottom: 10,
                            border: "1px solid rgb(235, 237, 240)",
                            display: "flex",
                            gap: 8,
                            alignItems: "center",
                        }}
                    >
                        <span style={{ fontWeight: 500 }}>
                            {porLote
                                ? `${seleccionados} lote(s) · ${this.totalArchivosSeleccionados()} archivo(s)`
                                : `${seleccionados} seleccionados`}
                        </span>
                        <ButtonItem
                            size="small"
                            morado
                            icon={<DownloadOutlined />}
                            disabled={this.state.descargando}
                            loading={this.state.descargando}
                            onClick={this.descargarSeleccionados.bind(this)}
                        >
                            Descargar ZIP
                        </ButtonItem>
                        <ButtonItem
                            size="small"
                            blanco
                            onClick={() => this.setState({ selectedRowKeys: [], seleccionados: {} })}
                        >
                            Cancelar
                        </ButtonItem>
                    </div>
                )}

                <TableItemDinamico
                    ref={(ref) => (this.tableRef = ref)}
                    onRef={(ref) => (this.tableRef = ref)}
                    onFetchData={this.consultarArchivos.bind(this)}
                    totalRecords={this.state.totalRecords}
                    dataSource={this.state.datos}
                    loading={this.state.loading}
                    columns={columns}
                    size="small"
                    rowKey={this.claveFila}
                    // El modo viaja por el canal `valor`, que es justo para lo que
                    // TableItemDinamico lo tiene. Asi la restauracion de filtros de
                    // localStorage repone el Segmented y la tabla en el mismo modo.
                    anadirValorFiltro={this.state.agrupar}
                    valorDefault="archivo"
                    setValor={(valor) => this.setState({ agrupar: valor })}
                    setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
                    valorTextoDefault={""}
                    filterStorageKey={this.claveStorage()}
                    onClearFilters={this.onLimpiarFiltros}
                    locale={{ emptyText: "No se encontraron archivos cargados en lotes" }}
                    rowSelection={{
                        selectedRowKeys: this.state.selectedRowKeys,
                        preserveSelectedRowKeys: true,
                        onChange: this.onChangeSeleccion,
                    }}
                    expandable={
                        porLote ? { expandedRowRender: this.filaExpandida } : undefined
                    }
                />

                <ModalItem
                    visible={this.state.previsualizar}
                    title={this.state.previsualizarNombre}
                    onCancel={this.cerrarPrevisualizar}
                    footer={null}
                    spinning={false}
                    width={this.state.previsualizarEsImagen ? 520 : 1000}
                >
                    {this.state.previsualizarEsImagen ? (
                        <img
                            alt={this.state.previsualizarNombre}
                            style={{ width: "100%" }}
                            src={this.state.previsualizarUrl}
                        />
                    ) : (
                        <iframe
                            src={this.state.previsualizarUrl}
                            title="Vista previa PDF"
                            style={{ width: "100%", height: "80vh", border: "none" }}
                        />
                    )}
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ArchivosLotes);
